module.exports = __webpack_public_path__ + "static/media/1-2_Art_Card_Two_Page_01.75be57dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/1-2_Art_Card_Two_Page_01.jpg
// module id = 1700
// module chunks = 0